// @flow
type AbTests = {
  [id: string]: [string, string, number] | [string, string, number, string],
}

// format: ["<a-name>", "<b-name>", "<threshold>", "<description>"]
// threshold == 0 -> only B
// threshold == 1 -> A=1/16 B=15/16
// threshold == 8 -> 50:50
// threshold == 16 -> only A

const abTests: AbTests = {
  AB0: ["A", "B", 8, "keep this test unassigned as AA for reference"],
  AB1: [
    "fetchServer",
    "fetchClient",
    0,
    "TODO put back fetch server after solving redis/other caching of homepage data",
  ],
  AB2: ["A", "B", 8],
  AB3: ["A", "B", 8],
  AB4: ["A", "B", 8, "keep this test unassigned as AA for reference"],
  AB5: ["A", "B", 8],
  AB6: ["A", "B", 8],
  AB7: [
    "A",
    "B",
    8,
    "warning: 7-0 is not tested and not tracked in GA, it also may not work due to uuid format",
  ],
  AB9: ["A", "B", 8, "keep this test unassigned as AA for reference"],
  AB10: ["A", "B", 8, "keep this test unassigned as AA for reference"],
  AB11: ["A", "B", 8],
  AB12: ["A", "B", 8, "do not use, broken!!"],
  AB13: ["enableLabs", "disableLabs", 0, "Hidden by default"],
  AB14: ["A", "B", 8],
  AB15: ["A", "B", 8],
  AB16: ["A", "B", 8],
  AB17: ["Loggly", "NoLoggly", 8],
  AB18: ["loadScheduleChangesFromLiveAPI", "scheduleChangesOff", 0, "Do not change"],
  AB19: ["A", "B", 8],
  AB20: ["mapMenuNextLabels", "mapMenuCharLabels", 8],
  AB21: ["googleTagManager", "B", 2, "A=2/16"],
  AB22: ["A", "B", 8],
  AB23: ["disabledMetaSearchAPI", "enabledMetaSearchAPI", 0], // full traffic
  AB24: ["groupedResults", "standaloneResults", 0],
  AB25: ["A", "B", 8],
  AB26: [
    "a",
    "b",
    8,
    "Investigating ab test. Does nothing, we want to check correct splitting users by language",
  ],
}

export default abTests
